// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'f6436211-8139-47c4-a3cf-ea6a840266fc',
      type: 'Container',
      name: 'wheelContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '7f97075a-dead-4cd5-a8fe-a13f86d35de9',
      type: 'Container',
      name: 'titleContainer',
      className: '',
      x: 0,
      y: -465,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '52e71b82-d0db-4587-89e3-e2a89b3c422a',
      type: 'Container',
      name: 'buttonContainer',
      className: '',
      x: 0,
      y: 415,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '4f9d38cc-a628-4578-8e31-bb5013a7afc4',
      type: 'Container',
      name: 'sectionsContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '505770ee-ed01-4e84-a713-a2068a8f108e',
      type: 'Sprite',
      name: 'wheelFrameTopLeft',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Quarter_Top',
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '8f29867a-572c-46ec-a2bd-5b1aacb98af7',
      type: 'Sprite',
      name: 'wheelFrameTopRight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Quarter_Top',
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '8cec2770-b8d6-497b-8700-46cad809d002',
      type: 'Sprite',
      name: 'wheelFrameBottomLeft',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Quarter_Bottom',
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '5a98d35e-3e29-4f93-a90f-fa87531544ce',
      type: 'Sprite',
      name: 'wheelFrameBottomRight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Quarter_Bottom',
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '9bbf0f66-ec33-4bde-a500-a4f771ae8191',
      type: 'Sprite',
      name: 'wheelMiddle',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Middle',
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '749b1bdc-71c3-40f8-9df5-a7ddd8a2d8d7',
      type: 'Sprite',
      name: 'pointer',
      className: '',
      x: 0,
      y: -265,
      anchor: {
        x: 0.5,
        y: 0.4
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Pointer',
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '53fe91e9-31cf-4a3f-8c64-54405bce78c0',
      type: 'Container',
      name: 'jackpotRewardContainer',
      className: '',
      x: 0,
      y: 28,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '39676931-6cb5-4ac0-a364-2a4ca7c01d77',
      type: 'Container',
      name: 'todayJackpotTextContainer',
      className: '',
      x: 0,
      y: -55,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f6436211-8139-47c4-a3cf-ea6a840266fc'
    },
    {
      id: '8b859910-64a0-4595-8967-51d25587f9da',
      type: 'Sprite',
      name: 'sectionPurple',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_Purple',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '1321fd2d-bd3f-4aa1-8222-00e69400795f',
      type: 'Sprite',
      name: 'sectionDarkBlue1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_Dark_Blue',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '2ec7b7ac-28b7-4a7e-bfd3-fd964beb2707',
      type: 'Sprite',
      name: 'sectionDarkBlue2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 135,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_Dark_Blue',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '2d9fdea8-1f0c-4926-a948-9c7dfb7f046d',
      type: 'Sprite',
      name: 'sectionDarkBlue3',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 225,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_Dark_Blue',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '683f3acf-919f-49d1-85b2-3afe35063c8c',
      type: 'Sprite',
      name: 'sectionDarkBlue4',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_Dark_Blue',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '4c1f4ef0-9210-41da-8aa7-33770c4a10a7',
      type: 'Sprite',
      name: 'sectionBlue1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 90,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_Blue',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '036489d8-dba1-4733-937b-e1af2cf43f1d',
      type: 'Sprite',
      name: 'sectionBlue2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_Blue',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '805c7270-1ad5-429f-bd0c-d52fe9a8c7a6',
      type: 'Sprite',
      name: 'sectionBlue3',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -90,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_Blue',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '1cc2cfed-6945-45f9-9c2b-68ffb0b14da1',
      type: 'Sprite',
      name: 'sectionWhite1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_White',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: 'd3c24a36-20ba-4fd3-a0e6-b5f12273e1d0',
      type: 'Sprite',
      name: 'sectionWhite2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 45,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_White',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: 'f01fb47f-2b1a-419a-9e94-cc06fcc1330d',
      type: 'Sprite',
      name: 'sectionWhite3',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 90,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_White',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '8cb2ada2-74be-4e62-824b-6fe9bd6228d4',
      type: 'Sprite',
      name: 'sectionWhite4',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 135,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_White',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '18ca93e9-3c28-498a-bd49-a9f53620fa13',
      type: 'Sprite',
      name: 'sectionWhite5',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_White',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '0a818934-d52a-498b-8034-f476bd73716f',
      type: 'Sprite',
      name: 'sectionWhite7',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -90,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_White',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '5b1e1754-6bd2-46fc-bc4f-02dd86dbdf88',
      type: 'Sprite',
      name: 'sectionWhite8',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -45,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Section_White',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '0e0452ff-b3bd-45c7-9c60-6c7bbc069d39',
      type: 'Sprite',
      name: 'separation1',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 112.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Separation',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '0da8f975-f66b-4368-9ec1-6e8087f56336',
      type: 'Sprite',
      name: 'separation2',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 157.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Separation',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: 'f779bc61-f9ca-411f-976e-0ce1209e2b08',
      type: 'Sprite',
      name: 'separation3',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 202.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Separation',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: 'e74efc4f-5593-4932-91f7-8089a61fb122',
      type: 'Sprite',
      name: 'separation4',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 247.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Separation',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: 'bb00ac05-005b-49c9-ab43-aaa4527d3b7a',
      type: 'Sprite',
      name: 'separation5',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 292.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Separation',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '7a2a5342-6b4b-4b28-a989-035f51f05127',
      type: 'Sprite',
      name: 'separation6',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 337.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Separation',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: 'f73c0586-bb3c-437b-8921-b964704448ad',
      type: 'Sprite',
      name: 'separation7',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 382.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Separation',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '3a9506d1-956b-4f4b-808c-2d64f1515260',
      type: 'Sprite',
      name: 'separation8',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 427.5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lucky_Wheel_Separation',
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: '174b45cd-4682-4acd-b9b3-20e977a8de84',
      type: 'Container',
      name: 'rewardContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4f9d38cc-a628-4578-8e31-bb5013a7afc4'
    },
    {
      id: 'c591fb9d-536d-43f1-a9b8-a7a3eab61be1',
      type: 'Sprite',
      name: 'jackpotRewardIcon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.95,
        y: 0.95
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Coin_Icon',
      parent: '53fe91e9-31cf-4a3f-8c64-54405bce78c0',
      data: {
        maxSize: 100
      }
    },
    {
      id: 'edd10349-b1c3-4492-9751-c6e44408b0b0',
      type: 'Text',
      name: 'jackpotRewardAmountText',
      className: '',
      x: 0,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xX',
      localize: false,
      maxWidth: 117,
      maxHeight: 75,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#6e0483',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '53fe91e9-31cf-4a3f-8c64-54405bce78c0'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'FreeSpin',
    'AdSpin',
    'NoSpin'
  ],
  animations: [
    {
      id: '5b3299ae-fcca-4773-bd3b-a3d191e6a8d9',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 620,
      blocks: [
        {
          id: '659edb53-6921-4df9-96b9-b00b79f6511b',
          type: 'Setter',
          name: 'blackAlpha',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'blackLayer',
          disabled: false
        },
        {
          id: '4ea15a90-769c-4e7f-bb61-44f80aa1c6c1',
          type: 'Setter',
          name: 'orangeGlowTitleAlpha',
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'orangeGlowTitle',
          disabled: false
        },
        {
          id: '233bc6a0-b4af-497b-a0bb-72f86caea435',
          type: 'Setter',
          name: 'titleScale',
          track: 7,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'titleContainer',
          disabled: false
        },
        {
          id: 'de276f1a-9e58-4c7c-8677-26d9a0743a99',
          type: 'Setter',
          name: 'wheelScale',
          track: 9,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'wheelContainer',
          disabled: false
        },
        {
          id: '1e8bcc64-233f-4ddf-9729-d58366b1f898',
          type: 'Setter',
          name: 'yellowGlowTitleAlpha_copy',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'yellowGlowTitle',
          disabled: false
        },
        {
          id: '5e763cb6-0c3e-489c-a4ae-b05a59326637',
          type: 'Setter',
          name: 'orangeGlowAlpha',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'orangeGlow',
          disabled: false
        },
        {
          id: '403453ba-4d3b-428f-ac9d-16fbf2b1e5cf',
          type: 'Setter',
          name: 'yellowGlowAlpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'yellowGlow',
          disabled: false
        },
        {
          id: '163ef095-a7ee-4788-abf7-e8de3f1257c9',
          type: 'Setter',
          name: 'raysAlpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'rays',
          disabled: false
        },
        {
          id: '29947c94-b54c-448a-8a89-face5a4af4c8',
          type: 'Setter',
          name: 'buttonScale',
          track: 11,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'buttonContainer',
          disabled: false
        },
        {
          id: '1c0e5c7f-4a7b-4a18-ab48-14e7c2757fa8',
          type: 'Setter',
          name: 'closeScale',
          track: 13,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          disabled: false
        },
        {
          id: 'f7b07191-0d00-4355-9b77-c3d205e08813',
          type: 'Tween',
          name: 'blackAlpha_1',
          duration: 150,
          track: 6,
          target: {
            alpha: 0.9
          },
          startAt: 20,
          sourceName: 'blackLayer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '88f410df-60bb-4804-855f-7459d3db05cb',
          type: 'Tween',
          name: 'titleScale_1',
          duration: 250,
          track: 7,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 70,
          sourceName: 'titleContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '991bafd9-4a1f-4228-a305-68a865118144',
          type: 'Tween',
          name: 'orangeGlowTitleAlpha_1_copy',
          duration: 400,
          track: 4,
          target: {
            alpha: 0.5
          },
          startAt: 70,
          sourceName: 'yellowGlowTitle',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e6c412cf-0748-44d8-949a-b9b0c874378a',
          type: 'Tween',
          name: 'orangeGlowTitleAlpha_1',
          duration: 400,
          track: 5,
          target: {
            alpha: 0.4
          },
          startAt: 70,
          sourceName: 'orangeGlowTitle',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1bd80f93-2045-40a9-905d-9bee01d4dd14',
          type: 'Tween',
          name: 'buttonScale_1',
          duration: 250,
          track: 11,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 70,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0de4f22d-aa30-4f01-bcc7-f564d092ab56',
          type: 'Tween',
          name: 'orangeGlowAlpha_1',
          duration: 400,
          track: 3,
          target: {
            alpha: 0.5
          },
          startAt: 120,
          sourceName: 'orangeGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f4f2acdc-a189-4b95-bdc3-c667a85ac7b8',
          type: 'Tween',
          name: 'wheelScale_1',
          duration: 250,
          track: 9,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 120,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'cc1c5d3a-91f0-41b1-ae15-49b277bfc8ba',
          type: 'Tween',
          name: 'yellowGlowAlpha_1',
          duration: 400,
          track: 2,
          target: {
            alpha: 0.4
          },
          startAt: 120,
          sourceName: 'yellowGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e9ecf2d6-ede4-4da9-a3d0-1f9acdabed67',
          type: 'Tween',
          name: 'raysAlpha_1',
          duration: 400,
          track: 1,
          target: {
            alpha: 0.6
          },
          startAt: 120,
          sourceName: 'rays',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '926ed159-5fb5-45f9-b5dd-0484d6bf1272',
          type: 'Tween',
          name: 'closeScale_1',
          duration: 250,
          track: 13,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 170,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '99971994-85ec-4a1c-bf77-2cfff0a1bdd2',
          type: 'Tween',
          name: 'titleScale_1_copy',
          duration: 200,
          track: 7,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 320,
          sourceName: 'titleContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'eed2403b-ea92-4a3c-a1fe-514b1af3b8d9',
          type: 'Tween',
          name: 'buttonScale_2',
          duration: 200,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 320,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '02c7686a-53fe-4a8c-a7f2-549b2f3d480e',
          type: 'Tween',
          name: 'wheelScale_2',
          duration: 200,
          track: 9,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 370,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'aaa2d22e-ff19-4d7f-a2d3-0c9f8672703e',
          type: 'Tween',
          name: 'closeScale_2',
          duration: 200,
          track: 13,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 420,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'd18da7a0-c7ba-4d6c-bb05-716c7734558c',
      name: 'Disappear',
      playingSpeed: 1,
      totalDuration: 570,
      blocks: [
        {
          id: '926ed159-5fb5-45f9-b5dd-0484d6bf1272',
          type: 'Tween',
          name: 'closeScale_1',
          duration: 250,
          track: 13,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f4f2acdc-a189-4b95-bdc3-c667a85ac7b8',
          type: 'Tween',
          name: 'wheelScale_1',
          duration: 250,
          track: 9,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 50,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1bd80f93-2045-40a9-905d-9bee01d4dd14',
          type: 'Tween',
          name: 'buttonScale_1',
          duration: 250,
          track: 11,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '88f410df-60bb-4804-855f-7459d3db05cb',
          type: 'Tween',
          name: 'titleScale_1',
          duration: 250,
          track: 7,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'titleContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0de4f22d-aa30-4f01-bcc7-f564d092ab56',
          type: 'Tween',
          name: 'orangeGlowAlpha_1',
          duration: 400,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'orangeGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'cc1c5d3a-91f0-41b1-ae15-49b277bfc8ba',
          type: 'Tween',
          name: 'yellowGlowAlpha_1',
          duration: 400,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'yellowGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e9ecf2d6-ede4-4da9-a3d0-1f9acdabed67',
          type: 'Tween',
          name: 'raysAlpha_1',
          duration: 400,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'rays',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e6c412cf-0748-44d8-949a-b9b0c874378a',
          type: 'Tween',
          name: 'orangeGlowTitleAlpha_1',
          duration: 400,
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'orangeGlowTitle',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '991bafd9-4a1f-4228-a305-68a865118144',
          type: 'Tween',
          name: 'orangeGlowTitleAlpha_1_copy',
          duration: 400,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'yellowGlowTitle',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'aaa2d22e-ff19-4d7f-a2d3-0c9f8672703e',
          type: 'Tween',
          name: 'closeScale_2',
          duration: 200,
          track: 13,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 250,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '02c7686a-53fe-4a8c-a7f2-549b2f3d480e',
          type: 'Tween',
          name: 'wheelScale_2',
          duration: 200,
          track: 9,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 300,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'eed2403b-ea92-4a3c-a1fe-514b1af3b8d9',
          type: 'Tween',
          name: 'buttonScale_2',
          duration: 200,
          track: 11,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 350,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '99971994-85ec-4a1c-bf77-2cfff0a1bdd2',
          type: 'Tween',
          name: 'titleScale_1_copy',
          duration: 200,
          track: 7,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 350,
          sourceName: 'titleContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f7b07191-0d00-4355-9b77-c3d205e08813',
          type: 'Tween',
          name: 'blackAlpha_1',
          duration: 100,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 470,
          sourceName: 'blackLayer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '996da59c-7c52-42ae-8d26-7bca5af86b40',
      name: 'Appear_Buttons',
      playingSpeed: 1,
      totalDuration: 620,
      blocks: [
        {
          id: '29947c94-b54c-448a-8a89-face5a4af4c8',
          type: 'Setter',
          name: 'buttonScale',
          track: 11,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'buttonContainer',
          disabled: false
        },
        {
          id: '1c0e5c7f-4a7b-4a18-ab48-14e7c2757fa8',
          type: 'Setter',
          name: 'closeScale',
          track: 13,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          disabled: false
        },
        {
          id: '1bd80f93-2045-40a9-905d-9bee01d4dd14',
          type: 'Tween',
          name: 'buttonScale_1',
          duration: 250,
          track: 11,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 70,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '926ed159-5fb5-45f9-b5dd-0484d6bf1272',
          type: 'Tween',
          name: 'closeScale_1',
          duration: 250,
          track: 13,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 170,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'eed2403b-ea92-4a3c-a1fe-514b1af3b8d9',
          type: 'Tween',
          name: 'buttonScale_2',
          duration: 200,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 320,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'aaa2d22e-ff19-4d7f-a2d3-0c9f8672703e',
          type: 'Tween',
          name: 'closeScale_2',
          duration: 200,
          track: 13,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 420,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'c1fcd44e-95dc-45a8-a69b-9666034938f9',
      name: 'Appear_Wheel',
      playingSpeed: 1,
      totalDuration: 620,
      blocks: [
        {
          id: 'de276f1a-9e58-4c7c-8677-26d9a0743a99',
          type: 'Setter',
          name: 'wheelScale',
          track: 9,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'wheelContainer',
          disabled: false
        },
        {
          id: 'f4f2acdc-a189-4b95-bdc3-c667a85ac7b8',
          type: 'Tween',
          name: 'wheelScale_1',
          duration: 250,
          track: 9,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 120,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '02c7686a-53fe-4a8c-a7f2-549b2f3d480e',
          type: 'Tween',
          name: 'wheelScale_2',
          duration: 200,
          track: 9,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 370,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'f51202eb-1adf-498f-857e-ff90d042d31f',
      name: 'Disappear_Wheel',
      playingSpeed: 1,
      totalDuration: 570,
      blocks: [
        {
          id: 'f4f2acdc-a189-4b95-bdc3-c667a85ac7b8',
          type: 'Tween',
          name: 'wheelScale_1',
          duration: 250,
          track: 9,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 50,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '02c7686a-53fe-4a8c-a7f2-549b2f3d480e',
          type: 'Tween',
          name: 'wheelScale_2',
          duration: 200,
          track: 9,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 300,
          sourceName: 'wheelContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '7975ad8f-d5b8-4084-887c-1c6bc2bc869c',
      name: 'Disappear_Buttons',
      playingSpeed: 1,
      totalDuration: 570,
      blocks: [
        {
          id: '926ed159-5fb5-45f9-b5dd-0484d6bf1272',
          type: 'Tween',
          name: 'closeScale_1',
          duration: 250,
          track: 13,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1bd80f93-2045-40a9-905d-9bee01d4dd14',
          type: 'Tween',
          name: 'buttonScale_1',
          duration: 250,
          track: 11,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'aaa2d22e-ff19-4d7f-a2d3-0c9f8672703e',
          type: 'Tween',
          name: 'closeScale_2',
          duration: 200,
          track: 13,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 250,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'eed2403b-ea92-4a3c-a1fe-514b1af3b8d9',
          type: 'Tween',
          name: 'buttonScale_2',
          duration: 200,
          track: 11,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 350,
          sourceName: 'buttonContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class TEMP_luckyWheel {
  static raw = raw;
  root!: Container;
  wheelContainer!: Container;
  titleContainer!: Container;
  buttonContainer!: Container;
  sectionsContainer!: Container;
  wheelFrameTopLeft!: Sprite;
  wheelFrameTopRight!: Sprite;
  wheelFrameBottomLeft!: Sprite;
  wheelFrameBottomRight!: Sprite;
  wheelMiddle!: Sprite;
  pointer!: Sprite;
  jackpotRewardContainer!: Container;
  todayJackpotTextContainer!: Container;
  sectionPurple!: Sprite;
  sectionDarkBlue1!: Sprite;
  sectionDarkBlue2!: Sprite;
  sectionDarkBlue3!: Sprite;
  sectionDarkBlue4!: Sprite;
  sectionBlue1!: Sprite;
  sectionBlue2!: Sprite;
  sectionBlue3!: Sprite;
  sectionWhite1!: Sprite;
  sectionWhite2!: Sprite;
  sectionWhite3!: Sprite;
  sectionWhite4!: Sprite;
  sectionWhite5!: Sprite;
  sectionWhite7!: Sprite;
  sectionWhite8!: Sprite;
  separation1!: Sprite;
  separation2!: Sprite;
  separation3!: Sprite;
  separation4!: Sprite;
  separation5!: Sprite;
  separation6!: Sprite;
  separation7!: Sprite;
  separation8!: Sprite;
  rewardContainer!: Container;
  jackpotRewardIcon!: Sprite & { data: typeof raw['list'][37]['data'] };
  jackpotRewardAmountText!: Text;
  StateName!: 'FreeSpin' | 'AdSpin' | 'NoSpin';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    blackLayer: object;
    orangeGlowTitle: object;
    titleContainer: object;
    wheelContainer: object;
    yellowGlowTitle: object;
    orangeGlow: object;
    yellowGlow: object;
    rays: object;
    buttonContainer: object;
    closeButton: object;
  };

  BlockTypeByName: {
    blackAlpha: object;
    orangeGlowTitleAlpha: object;
    titleScale: object;
    wheelScale: object;
    yellowGlowTitleAlpha_copy: object;
    orangeGlowAlpha: object;
    yellowGlowAlpha: object;
    raysAlpha: object;
    buttonScale: object;
    closeScale: object;
    blackAlpha_1: object;
    titleScale_1: object;
    orangeGlowTitleAlpha_1_copy: object;
    orangeGlowTitleAlpha_1: object;
    buttonScale_1: object;
    orangeGlowAlpha_1: object;
    wheelScale_1: object;
    yellowGlowAlpha_1: object;
    raysAlpha_1: object;
    closeScale_1: object;
    titleScale_1_copy: object;
    buttonScale_2: object;
    wheelScale_2: object;
    closeScale_2: object;
  };

  flowData = raw.animations[0];
}

export abstract class Disappear {
  Layout: {
    closeButton: object;
    wheelContainer: object;
    buttonContainer: object;
    titleContainer: object;
    orangeGlow: object;
    yellowGlow: object;
    rays: object;
    orangeGlowTitle: object;
    yellowGlowTitle: object;
    blackLayer: object;
  };

  BlockTypeByName: {
    closeScale_1: object;
    wheelScale_1: object;
    buttonScale_1: object;
    titleScale_1: object;
    orangeGlowAlpha_1: object;
    yellowGlowAlpha_1: object;
    raysAlpha_1: object;
    orangeGlowTitleAlpha_1: object;
    orangeGlowTitleAlpha_1_copy: object;
    closeScale_2: object;
    wheelScale_2: object;
    buttonScale_2: object;
    titleScale_1_copy: object;
    blackAlpha_1: object;
  };

  flowData = raw.animations[1];
}

export abstract class Appear_Buttons {
  Layout: {
    buttonContainer: object;
    closeButton: object;
  };

  BlockTypeByName: {
    buttonScale: object;
    closeScale: object;
    buttonScale_1: object;
    closeScale_1: object;
    buttonScale_2: object;
    closeScale_2: object;
  };

  flowData = raw.animations[2];
}

export abstract class Appear_Wheel {
  Layout: {
    wheelContainer: object;
  };

  BlockTypeByName: {
    wheelScale: object;
    wheelScale_1: object;
    wheelScale_2: object;
  };

  flowData = raw.animations[3];
}

export abstract class Disappear_Wheel {
  Layout: {
    wheelContainer: object;
  };

  BlockTypeByName: {
    wheelScale_1: object;
    wheelScale_2: object;
  };

  flowData = raw.animations[4];
}

export abstract class Disappear_Buttons {
  Layout: {
    closeButton: object;
    buttonContainer: object;
  };

  BlockTypeByName: {
    closeScale_1: object;
    buttonScale_1: object;
    closeScale_2: object;
    buttonScale_2: object;
  };

  flowData = raw.animations[5];
}
